export default __webpack_public_path__ + "static/media/Product-List.ccf112b0.jpg";